<template>
    <table>
        <thead>
            <tr class="border-b border-gray-300 bg-back-gray">
                <th class="py-[10px]"></th>
                <th 
                    v-for="header in data"
                    :key="header.durationInMonths"
                    class="py-[10px] text-sm text-center w-[400px]"
                >
                    {{ header.durationInMonths }} мес.
                </th>
                <hr class="w-full"/>
            </tr>
        </thead>
        <tbody>
            <tr 
                class="text-sm border-b border-gray-300 text-center"
            >
                <td class="p-[10px] w-[225px] text-center">Стандартный тариф</td>
                <td 
                    class="p-[10px] w-[400px]" 
                    v-for="price in data" 
                    :key="price.id"
                >
                    <span class="flex flex-col">
                        <span>
                            {{ useFormattedPrice(price.price) }} ₽
                            <span class="text-discount-price" v-if="shouldShowAdditionalText()">
                                (с 1 июля 50 000 ₽)
                            </span>
                        </span>
                        <span>
                            ({{ useFormattedPrice(calculatePerMonths(price.adjustedPrice, price.durationInMonths)) }} ₽/мес.)
                        </span>
                    </span>
                </td>
            </tr>
            <tr 
                class="text-sm border-b border-gray-300 text-center"
            >
                <td class="p-[10px] w-[225px] text-center">Тариф для участников ARDA</td>
                <td 
                    class="p-[10px] w-[400px]" 
                    v-for="price in data" 
                    :key="price.id"
                >
                    <span class="flex flex-col">
                        <span class="">
                            {{ useFormattedPrice(calculateDiscountedPrice(price.price, discountPercent)) }} ₽ 
                            <span class="text-discount-price" v-if="shouldShowAdditionalText()">
                                (с 1 июля 30 000 ₽)
                            </span>
                        </span>
                        <span>
                            ({{ useFormattedPrice(calculatePerMonths(calculateDiscountedPrice(price.adjustedPrice, discountPercent), price.durationInMonths)) }} ₽/мес.)
                        </span>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { getSubscribePeriods } from "@/api";
import { mainHandler } from "@/handlers";
import { useFormattedPrice } from "@/use/useFormattedPrice";
import { usePrice } from "@/use/usePrice";
import { ref, onMounted } from "vue";

export default {
    name: "SubscribeTariffTable",
    props: {
        discountPercent: {
            type: Number,
            required: true,
        },
    },
    setup() {
        const { calculateDiscountedPrice, calculatePerMonths } = usePrice();

        const data = ref([]);
        const errors = ref(null);
        const status = ref("pending");

        const getPriceAfterJuly = (price) => {
            const currentDate = new Date();
            const julyFirst = new Date(currentDate.getFullYear(), 6, 1);

            if (currentDate >= julyFirst) {
                price = price === 30000 ? 50000 : price === 18000 ? 30000 : price;
            }
            return price;
        };

        const fetchPeriodsData = async () => {
            try {
                const response = await getSubscribePeriods();
                const result = mainHandler(response.data);

                if (result.error) {
                    throw result.errors;
                }

                data.value = result.data.map((item) => ({
                    ...item,
                    adjustedPrice: getPriceAfterJuly(item.price),
                }));
                status.value = "success";
            } catch (error) {
                errors.value = error;
                status.value = "error";
            }
        };

        onMounted(fetchPeriodsData);

        return {
            data,
            errors,
            status,
            calculatePerMonths,
            calculateDiscountedPrice,
            useFormattedPrice,
            getPriceAfterJuly
        };
    },
    methods: {
        shouldShowAdditionalText() {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const julyFirst = new Date(currentYear, 6, 1);


            return currentDate < julyFirst;
        }
    }
};
</script>

<style scoped></style>
